export function getCollisionType(tile) {
    switch (tile) {
        case 0: return 'Walkable Tile';
        case 1: return 'Solid Tile';
        case 2: return 'Collapsible Tile'; // Unused
        case 3: return 'Hole'; // Crate hole
        case 4: return 'Crate';
        case 5: return 'Collectable';
        case 6: return 'Hole (walkable)';
        case 7: return 'Level End';
        case 8: return 'Locked Door';
        case 9: return 'Key';
        case 10: return 'Ice';
        case 11: return 'Level End (unlocked)';
        case 12: return 'Switch (press a)';
        case 13: return 'Switchable Block (default solid)';
        case 14: return 'Switchable Block (default walkable)'
        case 255: return 'Unused';
        default: return 'Unknown';
    }

}

export function getCollisionTypeDescription(tile) {
    switch (tile) {
        case 0: return 'Player and crates can move on this tile. The first occurrence of this tile will be the default tile used when other tiles disappear - such as when a crate is pushed into a hole.';
        case 1: return 'This tile blocks all movement of players and crates.';
        case 2: return 'Collapsible tile. Currently unused.';
        case 3: return 'Holes block player movement. When filled with a crate, this tile will be replaced with the default walkable tile.';
        case 5: return 'Collectable tiles can be picked up by the player; each one contributes toward the goal to unlock the exit. When collected, collectable tiles change into the default walkable tile.'
        case 6: return 'Walkable holes do not block player movement, but otherwise behave as holes do. When filled with a crate, this tile will be replaced with the default walkable tile.';
        case 7: return 'The level end tile behaves as any other walkable tile would until the level completion condition is met. At that point, it will transform into the "Level End Unlocked" tile, if present. Stepping on the tile after that point will take the player to the next level.';
        case 8: return 'The locked door tile will remain solid until the player touches it with a key. At that point, it will change to the default walkable tile.';
        case 9: return 'The key tile can be collected, allowing you to open a "Locked Door" tile using it. One key unlocks one door. Once unlocked, the door will be replaced with the default walkable tile.';
        case 10: return 'The ice tile will force the player to continue moving in the direction they were moving upon entering until they hit a wall or a non-ice block.';
        case 11: return 'The level end (Unlocked) tile is displayed once the player hits the win criteria for a level. It will end this level and move the user on to the next level.';
        case 12: return 'The switch block allows the user to press the A button (or x on a keyboard) to toggle the state of switchable blocks, the walkable ones become solid and vice versa.';
        case 13: return 'Switchable blocks alternate between being solid and being walkable when the player presses a switch. This one defaults to being solid when the level loads.';
        case 14: return 'Switchable blocks alternate between being solid and being walkable when the player presses a switch. This one defaults to being walkable when the level loads.';
        case 255: 
        default: return 'This block is not used and will not appear in tile selection in the map editor.'
    }
}